import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  WritableSignal,
  inject,
} from '@angular/core';
import { NgClass, TitleCasePipe } from '@angular/common';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { SwitchLanguageService } from '../../services';
import { LanguageInterface, LanguageType } from '../../types';

@Component({
  selector: 'ui-switch-language',
  imports: [TitleCasePipe, NgClass, NgbPopover],
  templateUrl: './switch-language.component.html',
  styleUrl: './switch-language.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchLanguageComponent implements OnInit {
  private switchLanguageService = inject(SwitchLanguageService);

  languagesData = input.required<LanguageInterface[]>();
  smallVersion = input<boolean>(false);
  currentLang!: WritableSignal<string>;

  ngOnInit() {
    this.currentLang = this.switchLanguageService.currentLang;
  }

  setLang(lang: LanguageType) {
    this.switchLanguageService.setTranslation(lang);
  }
}
